import { useHistory } from "react-router-dom";
import { NewsResponse } from "../../../../api/news";
import {
  CardItemWrapper,
  ChannelList,
  TextWrapper,
  Thumbnail,
  ThumbnailWrapper,
  Title,
  YoutubeWrapper,
  Text,
} from "../style/news";

const NormalNews = ({ list }: { list: NewsResponse[] }) => {
  const history = useHistory();
  if (list.length === 0) {
    return null;
  }

  return (
    <YoutubeWrapper>
      <Title>NEWS</Title>
      <ChannelList>
        {list.map((item) => (
          <CardItemWrapper
            key={item.id}
            onClick={() =>
              history.push(`/news-detail/${item.id}`, { fromNews: true })
            }
          >
            <ThumbnailWrapper>
              <Thumbnail src={item.mainImageKey} />
            </ThumbnailWrapper>
            <TextWrapper>
              <Text>{item.title}</Text>
            </TextWrapper>
          </CardItemWrapper>
        ))}
      </ChannelList>
    </YoutubeWrapper>
  );
};

export default NormalNews;
